export const draftTooltipInTreeIsHidden = 'draftTooltipInTreeIsHidden'
